<footer class="primary">
  <div layout="row" layout-align="center center" class="texto">
      <h3>Rodapé do site</h3>
  </div>
</footer>
